<!------------ START TEMPLATE ------------>
<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <span>Perfil</span>
        <v-select
          :options="perfis"
          name="Perfil"
          id="Perfil"
          v-model="idPerfil"
          @change="buscaDadosPermissoes"
          placeholder="Selecione um Perfil"
        ></v-select>
      </div>
    </div>
    <div v-if="idPerfil">
      <div
        v-for="agrupamento in formCadastro.agrupamento"
        :key="agrupamento.nomeAgrupamento"
      >
        <p class="my-4 tituloAgrupamento">
          {{ agrupamento.nomeAgrupamento }}
        </p>
        <vs-collapse type="border">
          <vs-collapse-item
            v-for="recurso in agrupamento.recursos"
            :key="recurso.idPermissoes"
          >
            <div slot="header">{{ recurso.nomePermissao }}</div>

            <ul class="inlineList">
              <li
                v-for="acao in recurso.acoes"
                :key="acao.nome + recurso.idPermissoes"
                class="flex flex-row justify-between"
              >
                <vs-checkbox
                  @change="updateSchema($event, recurso, acao)"
                  :vs-value="acao.nome"
                  :checked="acao.valor"
                  :disabled="!$can($actionsDefault.Escrita, subjectPermission)"
                >
                  {{ acao.nome }}
                </vs-checkbox>
                <vs-button
                  v-if="permissaoHistorico"
                  v-tooltip="'Histórico de Alterações'"
                  radius
                  color="primary"
                  type="flat"
                  icon-pack="feather"
                  icon="icon-list"
                  class="d-inline"
                  @click="abrirModalHistorico(idPerfil, recurso, acao)"
                ></vs-button>
              </li>
            </ul>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </div>
    <!------------ END TABELA ------------>
    <ModalHistorico
      :popupActive="popupActive"
      :perfil="perfil"
      :permissao="permissao"
      :acao="acao"
      @close="fecharModal"
    ></ModalHistorico>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import notify from './../../utils/notify';
import service from '../../services';
import vSelect from 'vue-select';
import ModalHistorico from '../modais/ModalHistoricoPermissoes.vue';

export default {
  components: {
    'v-select': vSelect,
    ModalHistorico,
  },
  props: ['subjectPermission'],
  data() {
    return {
      idEmpresa: null,
      dadosSideBar: {},
      idPerfil: null,
      controllerGeral: 'Permissoes',
      popupActive: false,
      perfis: [],
      selected: [],
      acoesPadroes: ['Leitura', 'Escrita', 'Inativar', 'Exportar'],
      itemsPerPage: 10,
      isMounted: false,
      formCadastro: {
        agrupamento: [],
      },
      perfil: {},
      permissao: {},
      acao: {},
    };
  },
  watch: {
    idPerfil() {
      this.buscaDadosPermissoes();
    },
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    permissaoHistorico() {
      return this.$can('Historico Alterações', 'Permissões');
    },
  },
  methods: {
    buscaDadosDomPermissoes() {
      this.$vs.loading();
      service
        .getAll('g', {}, 'domPermissoes/list/')
        .then((res) => {
          // Realiza a ordenação
          const result = res.data.sort((a, b) =>
            a.ordenacao > b.ordenacao ? 1 : -1,
          );

          // Criar um objeto com resutaldo do o agrupamento dos registro pelo campo 'agrupamento'
          const objAgrupamento = result.reduce((r, a) => {
            r[a.agrupamento] = r[a.agrupamento] || [];
            r[a.agrupamento].push(a);
            return r;
          }, Object.create(null));

          Object.keys(objAgrupamento).forEach((element) => {
            const agrupamento = {
              nomeAgrupamento: element,
              recursos: [],
            };

            const listPermissoes = objAgrupamento[element];

            listPermissoes.forEach((res) => {
              const acoes = this.recuperaAcoes(res);
              const recurso = {
                idPermissao: res.idPermissao,
                nomePermissao: res.nomePermissao,
                acoes,
              };
              agrupamento.recursos.push(recurso);
            });

            this.formCadastro.agrupamento.push(agrupamento);
          });

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    updateSchema(event, recurso, acao) {
      if (event.target) {
        acao.valor = event.target.checked;
        const postData = {
          idEmpresa: this.idEmpresa,
          idPerfil: this.idPerfil,
          idPermissao: recurso.idPermissao,
          permissao: recurso.nomePermissao,
          valor: acao.nome,
          status: acao.valor,
        };

        service
          .post(this.controllerGeral, 'AtualizaPermissao', postData)
          .then(() => {
            notify.notifySuccess(
              this.$vs,
              'Permissão atualizada com sucesso!',
              'Permissões',
            );
          })
          .catch((e) => {
            notify.notifyFail(this.$vs, e);
            this.$vs.loading.close();
          });
      }
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });
        });
    },
    buscaDadosPermissoes() {
      if (this.idPerfil) {
        this.$vs.loading();
        this.reiniciaRecursosAcoes();

        service
          .getAll(this.controllerGeral, {}, `list/${this.idPerfil.id}`)
          .then((res) => {
            res.data.forEach((element) => {
              const recurso = this.localizaRecurso(element.idPermissao);
              if (recurso) {
                const acao = recurso.acoes.find((x) => x.nome == element.valor);
                if (acao) {
                  acao.valor = true;
                }
              }
            });
            this.$vs.loading.close();
          })
          .catch((e) => {
            notify.notifyFail(this.$vs, e);
            this.$vs.loading.close();
          });
      }
    },
    recuperaAcoes(element) {
      const result = [];

      if (element.acoes) {
        const acoes = element.acoes.split(',');
        acoes.forEach((el) => {
          result.push({ nome: el, valor: false });
        });
      } else {
        this.acoesPadroes.forEach((el) => {
          result.push({ nome: el, valor: false });
        });
      }
      return result;
    },
    reiniciaRecursosAcoes() {
      for (let a = 0; a < this.formCadastro.agrupamento.length; a++) {
        const agrupamento = this.formCadastro.agrupamento[a];
        for (let r = 0; r < agrupamento.recursos.length; r++) {
          const recurso = agrupamento.recursos[r];
          for (let c = 0; c < recurso.acoes.length; c++) {
            const acoes = recurso.acoes[c];
            acoes.valor = false;
          }
        }
      }
    },
    localizaRecurso(idPermissao) {
      for (let a = 0; a < this.formCadastro.agrupamento.length; a++) {
        const agrupamento = this.formCadastro.agrupamento[a];
        for (let r = 0; r < agrupamento.recursos.length; r++) {
          const recurso = agrupamento.recursos[r];
          if (recurso.idPermissao == idPermissao) {
            return recurso;
          }
        }
      }
      return null;
    },
    abrirModalHistorico(perfil, permissao, acao) {
      this.perfil = perfil.id;
      this.permissao = permissao.idPermissao;
      this.acao = acao.nome;
      this.popupActive = true;
    },
    fecharModal() {
      this.popupActive = false;
    },
  },
  created() {
    this.buscaDadosDomPermissoes();
    this.buscaDadosSelects('perfis', 'perfis', 'nomePerfil', 'idPerfil');
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
.inlineList {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.inlineList li {
  margin: 0px 30px 0 30px;
}
.tituloAgrupamento {
  font-weight: 700;
}
.inlineList {
  flex-wrap: wrap;
  justify-content: normal !important;
}
.inlineList li {
  padding: 10px 0;
  width: 200px;
  overflow: hidden;
}
</style>

<!------------ END STYLE ------------>
